<template>
    <el-dialog
      :visible="showDialog"
    @close="handleClose()"
    >
<!--      <el-button class="el-icon-circle-close" @click="handleClose()" style="z-index: 9999;top: 0;right: 0;position: fixed;border-radius: 50%;height: 1.88vw;width: 1.88vw;padding-left: 8px;padding-top: 4px;font-size: 24px;"></el-button>-->
     <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="(item,index ) in imgs" :key="index" :value="item">
          <video v-if="item.uname.toString().endsWith('.mp4')" :src="item.url" controls="controls"/>
          <img v-if="!item.uname.toString().endsWith('.mp4')" :src="item.url"/>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
</template>

<script>
  export default {
    name: "History",
    props:{
      showDialog:{
        default:false
      },
      imgs:{
        type:Array,
        default: ()=>[]
      }
    },
    data() {
        return {
          input:''
        };
    },
    methods: {
      handleClose() {
        this.$emit('handle-close')
      }
    }
  }
</script>

<style lang="less" scoped>
/deep/.el-dialog{
  background: none;
  margin-top: calc(50% - 790px) !important;
  width: 100%;
  border-radius: 12px;
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
    color: #fff;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 30px;
  }
  .el-dialog__headerbtn{
    top: -133px;
  }
  .el-carousel__indicators--horizontal{
    display: none;
  }
  .el-carousel__arrow{
    background: #fff;
    color: #2A2A2A;
  }
  .el-carousel__arrow--left{
    left: 60px;
  }
  .el-carousel__arrow--right{
    right: 60px;
  }
  .el-carousel__container{
    height: 1000px;
  //  img{
  //    width: 1350px;
  //    height: 754px;
  //    border-radius: 8px;
  //  }
  }
  .el-dialog__headerbtn .el-dialog__close {
    position: fixed;
    top: 0;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue